<mat-form-field class="chip-list" appearance="fill">
  <mat-label>Tags</mat-label>
  <mat-chip-grid #chipGrid aria-label="Tags">
    @for (tag of listTags; track tag) {
      <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="remove(tag)"
      [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
      '--mat-chip-label-text-color': 'white' } : {}">
        {{tag.tagName}}
        @if (removable) {
          <button matChipRemove class="btn-remove-chip">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
    <input placeholder="Procurar tag..." #tagInput [formControl]="tagCtrl" [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)"
      (keydown.enter)="$event.preventDefault()">
    </mat-chip-grid>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (tag of filteredTags | async; track tag) {
        <mat-option [value]="tag">
          <span class="tag-option">
            @if (tag.colorCode) {
              <div class="color-tag" [ngStyle]="{'background-color': tag.colorCode}"></div>
            }
            {{tag.tagName}}
          </span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>